import Image from '@tiptap/extension-image'

export const Img = Image.extend({
  addAttributes() {
    return {
      ...this.parent(),
      class: { default: null },
      style: { default: "max-width: 100%;" },
      align: { default: null },
      width: { default: null },
      height: { default: null },
    };
  },
  // renderHTML({ HTMLAttributes }) {
  //   return ["img", HTMLAttributes];
  // },
});